import { RequiredFields } from 'reusable/useRequiredFields';

/**
 * EV-436。配送先の名前・説明の欄（名前 → 入力欄の id）。AddClient・EditClient が送る前に確かめ、
 * ClientInfo が欄に aria-required・aria-invalid と知らせを付ける。
 */
export const CLIENT_INFO_REQUIRED = { clientName: 'clientName', clientDescription: 'clientDescription' } as const;
export type ClientInfoRequired = RequiredFields<keyof typeof CLIENT_INFO_REQUIRED>;
